import { createAction, props } from '@ngrx/store';
import { createApiActions } from '@shared/ngrx-factory/factory.actions';
import { NonBpsSectionADtoInput } from '../requests/non-bps-seactiona.request';
import { NonBpsSectionBDtoInput } from '../requests/no-bps-sectionb.request';

export interface RequestState<T = any> {
  loading: boolean;
  message: string | null;
  response: T | null;
  error: any | null;
}

export interface CompanyResponse {
  success: boolean;
  message: string;
  data: any;
  statusCode: number;
}

export interface NonBpsRegistrationState {
  progress: RequestState<CompanyResponse>;
  attachmentTypes: RequestState<CompanyResponse>;
  productCategories: RequestState<CompanyResponse>;
  saveSectionA: RequestState<CompanyResponse>;
  verifyTin: RequestState<CompanyResponse>;
  saveSectionB: RequestState<CompanyResponse>;
  uploadAttachment: RequestState<CompanyResponse>;
  submitRegistration: RequestState<CompanyResponse>;
  loadOperatorByUuid: RequestState<CompanyResponse>;
  viewAttachment: RequestState<CompanyResponse>;
  deleteAttachment: RequestState<CompanyResponse>;
  completionPercentage: number;
  operatorUuid: string | null;
  sectionAComplete: boolean;
  sectionBComplete: boolean;
  sectionCComplete: boolean;
  allSectionsComplete: boolean;
  attachmentTypeList: any[];
  productCategoryList: any[];
}

export const NonBpsProgressActions = createApiActions<void, CompanyResponse>(
  'Non BPS Registration',
  'Load Progress',
);

export const NonBpsAttachmentTypesActions = createApiActions<void, CompanyResponse>(
  'Non BPS Registration',
  'Load Attachment Types',
);

export const NonBpsProductCategoriesActions = createApiActions<void, CompanyResponse>(
  'Non BPS Registration',
  'Load Product Categories',
);

export const NonBpsSectionAActions = createApiActions<NonBpsSectionADtoInput, CompanyResponse>(
  'Non BPS Registration',
  'Save Section A',
);

export const NonBpsTinVerificationActions = createApiActions<{ tin: string }, CompanyResponse>(
  'Non BPS Registration',
  'Verify TIN',
);

export const NonBpsSectionBActions = createApiActions<null, CompanyResponse>(
  'Non BPS Registration',
  'Save Section B',
);

export const NonBpsUploadAttachmentActions = createApiActions<
  {
    attachableUuid: string;
    registrationAttachmentTypeUuid: string;
    filename: string;
    extension: string | null;
    data: string;
  },
  CompanyResponse
>('Non BPS Registration', 'Upload Attachment');

export const NonBpsSubmitRegistrationActions = createApiActions<void, CompanyResponse>(
  'Non BPS Registration',
  'Submit Registration',
);

export const NonBpsLoadOperatorByUuidActions = createApiActions<string, CompanyResponse>(
  'Non BPS Registration',
  'Load Operator By UUID',
);

export const NonBpsViewAttachmentActions = createApiActions<string, CompanyResponse>(
  'Non BPS Registration',
  'View Attachment',
);

export const NonBpsDeleteAttachmentActions = createApiActions<string, CompanyResponse>(
  'Non BPS Registration',
  'Delete Attachment',
);

export const setNonBpsOperatorUuid = createAction(
  '[Non BPS Registration] Set Operator UUID',
  props<{ uuid: string | null }>(),
);

export const setNonBpsSectionCComplete = createAction(
  '[Non BPS Registration] Set Section C Complete',
  props<{ completed: boolean }>(),
);

export const clearNonBpsRegistrationState = createAction(
  '[Non BPS Registration] Clear State',
);
